import { render, staticRenderFns } from "./CustomizeChair.vue?vue&type=template&id=8e74d022&scoped=true&"
import script from "./CustomizeChair.vue?vue&type=script&lang=ts&"
export * from "./CustomizeChair.vue?vue&type=script&lang=ts&"
import style0 from "./CustomizeChair.vue?vue&type=style&index=0&id=8e74d022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e74d022",
  null
  
)

export default component.exports